import { Box, Button, Stack } from "@mui/joy";
import React, { useState } from "react";
import useSafeAreaInsets from "hooks/useSafeAreaInsets";
import useBottomSafePadding from "hooks/useBottomSafePadding";
import useSafeAreaColor from "hooks/useSafeAreaColor";
import { theme } from "styles/theme";
import ContentTemplateV2 from "components/task/content/ContentTemplateV2";
import image1 from "static/image/payment/typec/660_1.png";
import image2 from "static/image/payment/typec/660_2.png";
import image3 from "static/image/payment/typec/660_3.png";
import image4 from "static/image/payment/typec/660_4.png";
import image5 from "static/image/payment/typec/660_5.png";
import image6 from "static/image/payment/typec/660_6.png";
import image7 from "static/image/payment/typec/660_7.png";
import image8 from "static/image/payment/typec/660_8.gif";
import image9 from "static/image/payment/typec/660_9.png";
import image10 from "static/image/payment/typec/660_10.png";
import image11 from "static/image/payment/typec/660_11.png";
import image12 from "static/image/payment/typec/660_12.png";
import image13 from "static/image/payment/typec/660_13.png";
import image14 from "static/image/payment/typec/660_14.png";
import image15 from "static/image/payment/typec/660_15.png";
import image16 from "static/image/payment/typec/660_16.png";
import image20 from "static/image/payment/typec/660_20.png";
import payback from "static/image/payment/typec/payback.png";
import descision from "static/image/payment/typec/decision.png";
import { PRODUCT_SAFE_AREA_COLOR } from "styles/prePaintColors";

// ProductContent(앱 내 상품 상세)의 웹 단독 원페이지 버전 (distancing.im/product).
// 상품 상세·앱 소개용 공개 페이지. 비로그인이라 refundPolicyType 분기 없이
// 기본(payback) 이미지를 노출하고, CTA 는 OneLink 로 앱 설치/실행을 유도한다.
const CTA_ONELINK = "https://distancing.onelink.me/DeUR/uuvfo25n";

// 660_* 이미지 상단 가장자리 색. 모바일 Safari 상/하단 safe-area 를 페이지와
// 같은 톤으로 채우기 위해 html/body bg + theme-color 에 동기화 (하단 가장자리
// #20272B 와의 차이는 시각적으로 무의미).
const SAFE_AREA_COLOR = PRODUCT_SAFE_AREA_COLOR;

export default function ProductPage() {
  const { bottom: safeBottom } = useSafeAreaInsets();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - safeBottom
  );
  const floatingPb = useBottomSafePadding("8px");
  useSafeAreaColor(SAFE_AREA_COLOR);

  const body = (
    <ContentTemplateV2
      fullBleed
      disableBottomSafeArea
      isWide
      setContainerHeight={setContainerHeight}
    >
      {containerHeight > 0 && (
        <Stack
          sx={{
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "660px",
              mx: "auto",
            }}
          >
            <img
              src={image1}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image2}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image3}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image4}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image5}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image6}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image7}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image8}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image9}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image10}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image11}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image12}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image13}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image14}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image15}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image16}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={payback}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={descision}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
            <img
              src={image20}
              alt={"empty"}
              style={{
                width: "100%",
              }}
            />
          </Stack>

          {/* FloatingAreaPromotion 은 pl 20 / pr 32 비대칭 패딩이라 좌우 대칭 버전을 로컬로 구성 */}
          <Box
            sx={{
              position: "fixed",
              zIndex: 10,
              bottom: 0,
              left: 0,
              width: "100%",
              px: "20px",
              pt: "12px",
              pb: floatingPb,
            }}
          >
            <Stack
              alignItems="center"
              sx={{
                width: "100%",
                maxWidth: "620px",
                mx: "auto",
                paddingBottom: "8px",
              }}
            >
              <Button
                onClick={() => {
                  window.location.href = CTA_ONELINK;
                }}
                size={"lg"}
                sx={{
                  width: "100%",
                  fontWeight: 900,
                  fontSize: "18px",
                  backgroundColor: theme.vars.palette.Content.Highlight,
                  color: theme.vars.palette.Content.Negative,
                  // 떠 있는 느낌의 elevation 그림자
                  boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.28)",
                  "&:hover": {
                    backgroundColor: theme.vars.palette.Content.Highlight,
                  },
                }}
              >
                {"지금 앱으로 시작하기"}
              </Button>
            </Stack>
          </Box>
        </Stack>
      )}
    </ContentTemplateV2>
  );

  return body;
}
